export default "__VITE_ASSET__c4906496__"